module.exports = __webpack_public_path__ + "media/src/images/icons/email-1558c8126f7a93cb717c8a796a6824d5.svg";